import {ReactNode} from 'react';
import {selectIsSaleStateIng} from '../../../../common/selectIsSaleStateIng';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useLogin} from '../../../../user/useLogin.hook';
import {
  useContentHomeOverviewQuery,
  useSimpleSeriesSingleInfoQuery,
} from '../../../../wrapper/contentWrapper';

export interface ContentOnlyLoggedInOrSaleCheckerHeadlessProps {
  seriesId: number;
  /**
   * 뷰어에 접근한 경우에도 동일한 로직으로 판매중지를 체크합니다
   */
  productId?: number;
  /**
   * 판매중일 땐 children 을 보여줍니다
   */
  children?: ReactNode;
  /**
   * 판매중이 아닐 땐 ifStop 의 컴포넌트를 보여줍니다
   */
  ifStop?: ReactNode;
}

/**
 * 로그인 한 경우 - children 랜더링
 * 미로그인 경우 - 판매중인 경우만 children 랜더링
 */
export function ContentOnlyLoggedInOrSaleCheckerHeadless({
  seriesId,
  productId,
  children,
  ifStop,
}: ContentOnlyLoggedInOrSaleCheckerHeadlessProps) {
  const contentHomeData = useContentHomeOverviewQuery(
    {seriesId},
    ONLY_DATA_CONFIG
  ).data;

  const singleSimpleData = useSimpleSeriesSingleInfoQuery(
    {
      seriesId,
      productId,
    },
    ONLY_DATA_CONFIG
  ).data;

  const isSaleStateIng = selectIsSaleStateIng({
    data: contentHomeData,
    productId,
    singleSimpleData,
  });
  const {isLogin} = useLogin();

  if (isLogin || isSaleStateIng) {
    return <>{children}</>;
  } else {
    return <>{ifStop}</>;
  }
}
